import { ProductCategoryEntity } from "../entities/product-category.entity";

export abstract class ProductCategoryRepository {
   public abstract getById(id: string, renderOptions: boolean): Promise<ProductCategoryEntity>;
   public abstract getAll(): Promise<ProductCategoryEntity[]>;
}
